import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { objectValidator } from '#validation';
import { ssoUserIdentitySchema } from './identity';
export const SsoUserCreateSchema = z.object({
    userIdentity: objectValidator({
        object: ssoUserIdentitySchema,
        requiredError: 'user.userIdentity.required',
    }),
});
export class SsoUserCreateDto extends createZodDto(SsoUserCreateSchema) {
}
